import { motion } from "framer-motion";
import {
  ScanLine, Zap, Wrench, Snowflake, Lightbulb, Droplets, Package, BatteryCharging, PlugZap, ArrowUpRight,
} from "lucide-react";
import { SHOP_URL } from "@/constants/site";

const SERVICES = [
  {
    icon: ScanLine,
    title: "Диагностика",
    text: "Диагностика и кодиране на BMW с оригинална апаратура. Диагностика на Mercedes, AUDI, VW, SEAT, SKODA, OPEL, FORD и много други.",
  },
  {
    icon: Zap,
    title: "Стартови устройства",
    text: "Устройства за подаване на ток NOCO. Надеждни, удобни, ефективни. Могат да се ползват като зарядно за телефон, таблет и т.н. С вграден фенер.",
  },
  {
    icon: Wrench,
    title: "Механика",
    text: "Смяна на датчици, перки, вентилатори, свещи, бобини, ламбда сонди и др.",
  },
  {
    icon: Snowflake,
    title: "Автоклиматици",
    text: "Диагностика и ремонт на автоклиматици. Зареждане на автоклиматици. Смяна на дехидратори и купе филтри.",
  },
  {
    icon: Lightbulb,
    title: "Автолампи",
    text: "Всички видове автолампи за външно и вътрешно осветление. Ремонт и регулиране на фарове. Автолампи ксенон с до 4 г. гаранция.",
  },
  {
    icon: Droplets,
    title: "Обслужване",
    text: "Смяна на масла и филтри. Нулиране на сервизни интервали и инспекции.",
  },
  {
    icon: Package,
    title: "Части и консумативи",
    text: "Търговия, монтаж и гаранция на оригинални и алтернативни резервни части и консумативи. Работим предимно с немски марки леки автомобили и джипове.",
  },
  {
    icon: BatteryCharging,
    title: "Акумулатори",
    text: "Търговия, монтаж, сервиз и кодиране на акумулатори BANNER, BOSCH, VARTA, GIGAWAT, YUASA, FULBAT и др.",
    link: SHOP_URL,
  },
  {
    icon: PlugZap,
    title: "Зарядни устройства",
    text: "Автоматични зарядни устройства CTEK, NOCO и BOSCH за акумулатори 1.2 – 500 Ah. Стартови устройства NOCO Genius Boost.",
    link: SHOP_URL,
  },
];

export default function Services() {
  return (
    <section id="services" className="relative bg-[#0A0A0A] py-24 lg:py-32" data-testid="services-section">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="mb-16"
        >
          <p className="mb-4 flex items-center gap-3 text-xs font-bold uppercase tracking-[0.35em] text-[#39FF14]">
            <span className="font-display text-stroke-green text-3xl">01</span> Дейности
          </p>
          <h2 className="font-display text-3xl font-extrabold uppercase tracking-tight sm:text-5xl">
            Какво правим <span className="text-[#39FF14]">за вас</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 gap-px border border-white/10 bg-white/10 md:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.article
                key={s.title}
                data-testid={`service-card-${i}`}
                initial={{ opacity: 0, y: 32 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: (i % 3) * 0.12 }}
                className="group relative flex flex-col bg-[#0D0D0D] p-8 transition-colors duration-300 hover:bg-[#111411]"
              >
                <div className="mb-6 flex items-start justify-between">
                  <div className="flex h-14 w-14 items-center justify-center bg-[#008A22] text-white transition-colors duration-300 group-hover:bg-[#39FF14] group-hover:text-black">
                    <Icon size={26} strokeWidth={2} />
                  </div>
                  <span className="font-display text-sm text-zinc-700 transition-colors duration-300 group-hover:text-[#39FF14]/60">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3 className="mb-3 font-display text-lg font-bold uppercase tracking-wide text-white">
                  {s.title}
                </h3>
                <p className="text-sm leading-relaxed text-zinc-400">{s.text}</p>
                {s.link && (
                  <a
                    data-testid={`service-link-${i}`}
                    href={s.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-5 inline-flex items-center gap-2 text-sm font-bold uppercase tracking-widest text-[#39FF14] transition-colors duration-300 hover:text-[#32E612]"
                  >
                    Към магазина
                    <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </a>
                )}
                <div className="pointer-events-none absolute inset-x-0 bottom-0 h-0.5 origin-left scale-x-0 bg-[#39FF14] transition-transform duration-500 group-hover:scale-x-100" />
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
